async function retrieveVideoData(videoId) {
  try {
    const response = await fetch(`/apps/potato/request-video`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ v: videoId }),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const dataString = await response.json();

    return dataString.data;
  } catch (error) {
    console.error("Error fetching video data:", error);
    return null;
  }
}

async function populateVideoPlayer() {
  const videoContainer = document.getElementById("video-container");
  const videoId = videoContainer ? videoContainer.dataset.videoid : null;

  if (!videoId) {
    console.log("No video ID found.");
    return;
  }

  const videoData = await retrieveVideoData(videoId);

  if (!videoData) {
    console.log("Could not retrieve video data.");
    return;
  }

  const videoElement = document.querySelector(".video");
  const downloadButton = document.querySelector(".download-button");
  const progressBarImage = document.querySelector(".progress-bar img");

  const thumbnailUrl = `/apps/potato/vimeo/${videoData.thumbnailUrl}`;

  if (videoElement) {
    videoElement.src = videoData.videoUrl;
    videoElement.poster = thumbnailUrl;
  }

  if (downloadButton) {
    downloadButton.href = videoData.downloadUrl;
  }

  if (progressBarImage) {
    progressBarImage.src = thumbnailUrl;
  }

  videoContainer.style.display = "block";

  videoContainer.dataset.videoid = "";
}

populateVideoPlayer();
